module.exports = __webpack_public_path__ + "img/primary-button-background-color.09f67693.svg";